import { defaultPageMetaConfig, PageMetaConfig } from '@spartacus/core';

const defaultResolvers = defaultPageMetaConfig.pageMeta?.resolvers ?? [];
const resolvers = [...defaultResolvers, { property: 'metaTitle', method: 'resolveMetaTitle' }];

export const PAGE_META_CONFIG: PageMetaConfig = {
  pageMeta: { resolvers, canonicalUrl: defaultPageMetaConfig?.pageMeta?.canonicalUrl }
};
